export const resolveAbsoluteUrl = (path: string, baseUrl: string) => {
    if (path.startsWith('http')) {
        return path;
    }
    return `${baseUrl}${path}`;
};
